import { ComboModel } from '../components/combo/combo-model';
import { JournalFileType } from '../enums/journal-file-type.enum';
import { SortHelper } from '../helpers/sort-helper';

export class JournalFileTypeHelper {
  public static buildOptions(): ComboModel[] {
    const options = new Array<ComboModel>();
    options.push(this.convertToComboModel(JournalFileType.Fec)!);
    options.push(this.convertToComboModel(JournalFileType.Pdf)!);
    options.push(this.convertToComboModel(JournalFileType.Xlsx)!);
    options.sort(SortHelper.sortByLabelAlphabetically);
    return options;
  }

  public static convertToComboModel(enumValue: JournalFileType): ComboModel | null {
    if (Object.values(JournalFileType).includes(enumValue)) {
      const comboModel = new ComboModel();
      comboModel.key = enumValue.valueOf().toString();
      comboModel.label = this.translateEnum(enumValue);
      return comboModel;
    } else {
      return null;
    }
  }

  public static convertToEnum(comboModel: ComboModel): JournalFileType | undefined {
    if (comboModel) {
      if (comboModel.key === JournalFileType.Fec.valueOf().toString()) {
        return JournalFileType.Fec;
      } else if (comboModel.key === JournalFileType.Pdf.valueOf().toString()) {
        return JournalFileType.Pdf;
      } else if (comboModel.key === JournalFileType.Xlsx.valueOf().toString()) {
        return JournalFileType.Xlsx;
      }
    }

    return undefined;
  }

  public static translateEnum(enumValue: JournalFileType): string | undefined {
    if (enumValue === JournalFileType.Fec) {
      return 'FEC';
    } else if (enumValue === JournalFileType.Pdf) {
      return 'PDF';
    } else if (enumValue === JournalFileType.Xlsx) {
      return 'Excel';
    }
    return undefined;
  }
}
